<template>
    <div class="teachersDetail_home">
        <div class="td1">
            <img class="td1_img" :src="'https://public.rossoarts.com/static/uploads/teacher/' + tutorsData.avatar" alt="">
            <p class="p1">{{ tutorName }}</p>
            <div>
                <p class="p2"><span>所学专业：</span>{{ tutorsData.major }}</p>
                <p class="p2"><span>毕业院校：</span>{{ tutorsData.school | allSchool }}</p>
            </div>
            <div class="btn" @click="coverInp()">
                <img src="../img/icon5.png" alt="">
                <p>在线提问</p>
            </div>
        </div>
        <div class="td2">
            <div class="td_title">
                <p class="p1">导师简介</p>
                <p class="p2">TUTOR INTRO</p>
            </div>
            <div class="td2_cont">
                {{ tutorsData.honor }}
            </div>
        </div>
      
        <div class="td4">
            <div class="td_title">
                <p class="p1">录取案例</p>
                <p class="p2">OFFER CASES</p>
            </div>
            <div class="td4_cont">
                 <!-- <div class="td3_item"  v-for="(item,index) in luSchool" @click="jopSchoolDetail(item.id,item.cname)">
                    <img :src="'https://public.rossoarts.com/static/uploads/'+item.logo" alt="">
                    <img  class="td3_hid" src="../img/Group 770.png" alt="">
                </div> -->
            </div>
        </div>

        <div class="tutors5">
            <div class="section_box">
                <div class="section_title_cn">iTUTOR导师专访</div>
                <div class="section_title_en">ITUTOR INTERVIEW</div>
            </div>
            <div class="t5_cont">
                <div class="swiper mySwiperT3">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in artsTutor">
                            <div class="t5_item" @click="jopNewsDetail(item.id)">
                                <div class="t5_kuang">
                                    <div class="t5_icon t5_icon1">
                                        <div></div>
                                    </div>
                                    <div class="t5_icon t5_icon2">
                                        <div></div> 
                                    </div>
                                    <div class="t5_icon t5_icon3">
                                        <div class="t5_icon3_1"></div>
                                        <div class="t5_icon3_2"></div>

                                    </div>
                                </div>
                                <img :src="'https://public.rossoarts.com/static/uploads/article/' + item.list_img" alt="">
                                <div class="t5_bottom">
                                    {{ item.title }}
                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>

        <div class="tutors6">
            <div class="section_box">
                <div class="section_title_cn">热门回答</div>
                <div class="section_title_en">POPULAR Q&A</div>
            </div>
            <div class="t6_cont">
                <div class="swiper mySwiperT4">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in qaData">
                            <div v-for="(item2, index2) in item" class="t6_item" @click="t6Show(index*3 + index2)">
                                <div class="t6_item_show">
                                    <div>Q：{{ item2.question }}</div>

                                </div>

                                <div class="grid">
                                    <div class="t6_item_hid">
                                        <div style="margin-top: .2rem;margin-bottom: .2rem;">A：{{ item2.answer }}</div>

                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import axios from "axios"
import "@/assets/css/teacherDetail.css"
import Swiper from 'swiper/bundle'
import 'swiper/css/pagination';
import "@/assets/css/tutors.css"
export default {
    data() {
        return {
            tutorsData: [],
            tutorName: "",
            artsTutor: [],
            qaData: [],
            qaTotal: [],
            luSchool:[],
        }
    },
    filters: {
        allSchool(val) {

            if (val) {
                return val.split(',')[0]
            }

        },
    },
    created() {
        this.getTeacherDetail(this.$route.params.id.split(".")[0])
        this.getArtsNew()
        this.getQa()
    },
    methods: {
        jopSchoolDetail(val,val2){
            this.$router.push({
              
              path:  `/schools/${val}.html?cname=${val2}`,
            
          })
        },
        coverInp() {
            var coverBlack2 = document.getElementById("coverBlack2")
            coverBlack2.style.display = "block"

        },
        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
        jopNewsDetail(val){
            this.$router.push(`/news/${val}.html`)
        },
        t6Show(val2) {
            console.log(val2, 'val2')
            var val = val2 
            // console.log('val2',val2,"val",val);
            var t6_item = document.getElementsByClassName("t6_item")
            var grid = document.getElementsByClassName("grid")
            var t6_item_show = document.getElementsByClassName("t6_item_show")
            var t6_item_hid = document.getElementsByClassName("t6_item_hid")
            // t6_item_hid[val].style.height = "auto"
            // this.flag = !this.flag
            // console.log(grid, val);
            if (grid[val].style.gridTemplateRows == "0fr") {
                // 不出
                // console.log("合起");
                grid[val].style.gridTemplateRows = "1fr";
                // t6_item_show[val].style.backgroundColor = "#5f9df7"
                // t6_item_show[val].style.border = "none"
                // t6_item_show[val].style.margin = "0rem"

            } else {
                // 出
                // console.log("展开");
                grid[val].style.gridTemplateRows = "0fr";
                // t6_item_show[val].style.backgroundColor = "#FB6333"
                // t6_item_show[val].style.border = ".02rem solid #000"
                // t6_item_show[val].style.margin = "-0.02rem -0.02rem 0 -0.02rem"

            }
        },
        getArtsNew() {
            axios.get("https://public.rossoarts.com/api/v1/getArtsNews?category=30&limit=12&page=1").then((data) => {
                // console.log(data.data.data.data, "导师分享");
                this.artsTutor = data.data.data.data
                this.$nextTick(() => {
                    this.swiperT3()
                })
            })
        },
         getQa() {
            axios.get(`https://public.rossoarts.com/api/v1/getQa?limit=18&page=1`).then((data) => {
                // console.log(data.data.data);
                this.qaData = this.arrGroup(data.data.data, 3)
                // this.qaTotal = data.data.total
                this.$nextTick(() => {
                    this.swiperT4()
                })
                // this.artsTutor = this.arrGroup(data.data.data.data, 4)
            })
        },
        getTeacherDetail(val) {
            axios.get(`https://public.rossoarts.com/api/getTeacher?id=${val}`).then((data) => {
                // console.log(data.data.data);
                this.luSchool = data.data.data.school_case.slice(0,8)
                this.tutorsData = data.data.data
                this.studentRate = data.data.data.success_rate
                this.studentNum = data.data.data.student_num
                if (data.data.data.category == "2") {
                    this.tutorName = "Prof." + this.tutorsData.name
                } else {
                    this.tutorName = this.tutorsData.name
                }
            })
        },
        swiperT3() {
            var swiper = new Swiper(".mySwiperT3", {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '">' + "</span>";
                    },
                },
                loop: true,
            });

        },
        swiperT4() {
            var swiper = new Swiper(".mySwiperT4", {
                autoHeight: true,
                // spaceBetween: 20,
                // loop: true,
                observer:true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        },
    }
}
</script>